// Landing Page Themes Index
export { default as ModernTheme } from './ModernTheme';
export { default as ClassicTheme } from './ClassicTheme';
export { default as VibrantTheme } from './VibrantTheme';
export { default as MinimalTheme } from './MinimalTheme';
export { default as ProfessionalTheme } from './ProfessionalTheme';
export { default as AuroraTheme } from './AuroraTheme';
export { default as MidnightTheme } from './MidnightTheme';
export { default as EditorialTheme } from './EditorialTheme';
export { default as PlayfulTheme } from './PlayfulTheme';
export { default as ZenTheme } from './ZenTheme';

// Theme metadata for selection UI
// swatchBg / swatchFg drive the colour swatch in WebsiteSettings
export const THEMES = {
  modern: {
    id: 'modern',
    name: 'Modern',
    description: 'Clean, minimal design with card-based layout',
    preview: '/placeholders/theme-modern.png',
    swatchBg: '#fafafa',
    swatchFg: '#333333',
  },
  classic: {
    id: 'classic',
    name: 'Classic',
    description: 'Traditional, warm design with serif fonts',
    preview: '/placeholders/theme-classic.png',
    swatchBg: '#FDF8F3',
    swatchFg: '#D4AF37',
  },
  vibrant: {
    id: 'vibrant',
    name: 'Vibrant',
    description: 'Bold colors with gradients and animations',
    preview: '/placeholders/theme-vibrant.png',
    swatchBg: '#0F0F1A',
    swatchFg: '#8B5CF6',
  },
  minimal: {
    id: 'minimal',
    name: 'Minimal',
    description: 'Ultra-simple with lots of whitespace',
    preview: '/placeholders/theme-minimal.png',
    swatchBg: '#ffffff',
    swatchFg: '#333333',
  },
  professional: {
    id: 'professional',
    name: 'Professional',
    description: 'Corporate feel with structured layout',
    preview: '/placeholders/theme-professional.png',
    swatchBg: '#F8F9FA',
    swatchFg: '#333333',
  },
  aurora: {
    id: 'aurora',
    name: 'Aurora',
    description: 'Glassmorphism cards on an animated aurora gradient',
    preview: '/placeholders/theme-aurora.png',
    swatchBg: '#0d1a2e',
    swatchFg: '#93C5FD',
  },
  midnight: {
    id: 'midnight',
    name: 'Midnight',
    description: 'Dark luxe with gold accents and serif elegance',
    preview: '/placeholders/theme-midnight.png',
    swatchBg: '#0B0F1A',
    swatchFg: '#C9A84C',
  },
  editorial: {
    id: 'editorial',
    name: 'Editorial',
    description: 'Magazine-style with oversized headlines and pull quotes',
    preview: '/placeholders/theme-editorial.png',
    swatchBg: '#FAFAF8',
    swatchFg: '#1A1A1A',
  },
  playful: {
    id: 'playful',
    name: 'Playful',
    description: 'Neo-memphis with bold colors and bouncy animations',
    preview: '/placeholders/theme-playful.png',
    swatchBg: '#FFE14D',
    swatchFg: '#1A1A1A',
  },
  zen: {
    id: 'zen',
    name: 'Zen',
    description: 'Calm earth palette, generous whitespace, serene fades',
    preview: '/placeholders/theme-zen.png',
    swatchBg: '#EDE9E3',
    swatchFg: '#7A9E7E',
  },
};

// Get theme component by name
export const getThemeComponent = (themeName) => {
  const themes = {
    modern: require('./ModernTheme').default,
    classic: require('./ClassicTheme').default,
    vibrant: require('./VibrantTheme').default,
    minimal: require('./MinimalTheme').default,
    professional: require('./ProfessionalTheme').default,
    aurora: require('./AuroraTheme').default,
    midnight: require('./MidnightTheme').default,
    editorial: require('./EditorialTheme').default,
    playful: require('./PlayfulTheme').default,
    zen: require('./ZenTheme').default,
  };
  return themes[themeName] || themes.modern;
};
